export default __webpack_public_path__ + "static/media/nebraska.035de744.jpg";